export default "__VITE_ASSET__Cow6iWp4__"